import { Injectable } from '@angular/core';

import { ConfirmModel, ErrorModel, ErweiterteAuftraggeberSucheModel, MessageModel } from '../model.module/modals.model';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MessageObservable {

    behaviourSubject: BehaviorSubject<MessageModel> = new BehaviorSubject(null) as BehaviorSubject<MessageModel>;
    observable: Observable<MessageModel> = this.behaviourSubject.asObservable();

    notify(messageModel: MessageModel): void {
        this.behaviourSubject.next(messageModel);
    }

    subscribe(fn: (message: MessageModel) => void): void {
        this.observable.subscribe(fn);
    }

}

@Injectable({
    providedIn: 'root'
})
export class ConfirmationObservable {

    private readonly behaviourSubject: BehaviorSubject<MessageModel>;
    private readonly observable: Observable<MessageModel>;

    constructor() {
        this.behaviourSubject = new BehaviorSubject(null);
        this.observable = this.behaviourSubject.asObservable();
    }

    notify(confirmModel: ConfirmModel): void {
        this.behaviourSubject.next(confirmModel);
    }

    subscribe(fn: (confirm: ConfirmModel) => void): Subscription {
        return this.observable.subscribe(fn);
    }

}

@Injectable({
    providedIn: 'root'
})
export class ErrorObservable {

    private readonly behaviourSubject: BehaviorSubject<MessageModel>;
    private readonly observable: Observable<MessageModel>;

    constructor() {
        this.behaviourSubject = new BehaviorSubject(null);
        this.observable = this.behaviourSubject.asObservable();
    }

    notify(errorModel: ErrorModel): void {
        this.behaviourSubject.next(errorModel);
    }

    subscribe(fn: (error: ErrorModel) => void): Subscription {
        return this.observable.subscribe(fn);
    }

}

@Injectable({
    providedIn: 'root'
})
export class ErweiterteAuftraggeberSucheObservable {

    private readonly behaviourSubject: BehaviorSubject<ErweiterteAuftraggeberSucheModel>;
    private readonly observable: Observable<ErweiterteAuftraggeberSucheModel>;

    constructor() {
        this.behaviourSubject = new BehaviorSubject(null);
        this.observable = this.behaviourSubject.asObservable();
    }

    notify(erweiterteAuftraggeberSucheModel: ErweiterteAuftraggeberSucheModel): void {
        this.behaviourSubject.next(erweiterteAuftraggeberSucheModel);
    }

    subscribe(fn: (model: ErweiterteAuftraggeberSucheModel) => void): Subscription {
        return this.observable.subscribe(fn);
    }

}
